import React from "react";
import "./HealthTwoStories.scss";

const HealthTwoStories = () => {
  const reels = [
    {
      id: 1,
      title: "Video 1",
      embedUrl: "https://www.youtube.com/embed/nilGxTkWAbU",
    },
    {
      id: 2,
      title: "Video 2",
      embedUrl: "https://www.youtube.com/embed/FQ-v2-JWP6Q",
    },
    {
      id: 3,
      title: "Video 3",
      embedUrl: "https://www.youtube.com/embed/f3fRby_1k3A",
    },
    {
      id: 4,
      title: "Video 4",
      embedUrl: "https://www.youtube.com/embed/yXaoUsdtRjU",
    },
    {
      id: 5,
      title: "Video 5",
      embedUrl: "https://www.youtube.com/embed/3T_6B9qhh24",
    },
  ];

  return (
    <section className="health-two-stories">
      <h2 className="section-title">Healthy Life Stories</h2>
      <div className="story-scroll">
        {reels.map((reel) => (
          <div className="story-card" key={reel.id}>
            <div className="video-wrapper">
              <iframe
                src={`${reel.embedUrl}?mute=1&playsinline=1&autoplay=0`}
                title={reel.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="story-title">{reel.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HealthTwoStories;
